import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from './auth.service';
import { UserRoleEnum } from './user-roles.enum';

export const roleGuard = (role: UserRoleEnum): CanActivateFn =>
  () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    return auth.typedPayload$.pipe(
      map(payload => {
        if (!payload || payload.role !== role) {
          router.navigate(['']);
          return false;
        }
        return true;
      })
    );
  };
